function toggleLongText() {
  const longTexts = document.querySelectorAll(".long-text");
  for (let i = 0; i < longTexts.length; i++) {
    const longText = longTexts[i];
    longText.querySelector(".long-text__controller").addEventListener("click", function(e) {
      longText.parentNode.querySelector(".long-text__text").classList.toggle("long-text__text--collapsed");
    });
  }
}
toggleLongText();
